<template>
  <chart-component>
    <!-- Title -->
    <template #title>
      {{ $t('breakdown') }}
    </template>
    <!-- /Title -->
    <!-- Subtitle -->
    <template #subtitle>
      {{ $t('pages.businessGuide.monthlyAverage') }}
    </template>
    <!-- /Subtitle -->
    <!-- Chart -->
    <template #chart>
      <distribution-of-direct-costs-chart
        hide-title
        format-labels
        :chart-animations="chartAnimations"
      />
    </template>
    <!-- /Chart -->
    <!-- Right side -->
    <template #right-side>
      <chart-component-right-side>
        <total-amount
          class="mb-3"
          :amount="totalAmount"
          :text="$t('totalMonthlyAverage')"
        />
        <div>
          <p class="m-0 text-small mb-4">
            {{ $t('topThreeAverage') }}
          </p>
          <template v-for="(topDirectCost, index) in directCostsAverageData">
            <year-info
              :key="index"
              class="mb-3"
              :avatar-text="index + 1"
              :text="topDirectCost.name"
              circle
              :money="topDirectCost.average"
            />
          </template>
        </div>
      </chart-component-right-side>
    </template>
    <!-- /Right side -->
  </chart-component>
</template>

<script>
import ChartComponent from '@/views/Home/StoryMode/FinancialPlan/Components/ChartComponent'
import ChartComponentRightSide from '@/views/Home/StoryMode/FinancialPlan/Components/ChartComponentRightSide'
import DistributionOfDirectCostsChart from '@/views/Home/StoryMode/Forecast/DirectCosts/Charts/DistributionOfDirectCostsChart'
import TotalAmount from '@/views/Home/StoryMode/FinancialPlan/Components/TotalAmount'
import YearInfo from '@/views/Home/StoryMode/FinancialPlan/Components/YearInfo'

export default {
  name: 'DistributionOfDirectCosts',

  components: {
    ChartComponentRightSide,
    ChartComponent,
    DistributionOfDirectCostsChart,
    TotalAmount,
    YearInfo
  },

  props: {
    chartAnimations: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    directCostsAverageData () {
      let result = []

      if (this.$store.state.idea.storyMode.forecast.directCosts.breakdown.data) {
        result = this.$store.state.idea.storyMode.forecast.directCosts.breakdown.data
      }

      return result
    },

    totalAmount () {
      let result = 0

      if (this.$store.state.idea.storyMode.forecast.directCosts.breakdown.total) {
        result = this.$store.state.idea.storyMode.forecast.directCosts.breakdown.total
      }

      return result
    }
  }
}
</script>
